// extracted by mini-css-extract-plugin
export default {"cardIcon":"cardIcon__g37iU","companyOption":"companyOption__RzBbW","cardStatusLocked":"cardStatusLocked__9ViyX"};